import React from 'react';
import { ForgeInlineMessage, ForgeCircularProgress } from '@tylertech/forge-react';

interface PDFPreviewProps {
  pdfData: string | null;
  loading: boolean;
  hasTooMayRows: boolean;
}

const renderMessage = (theme: string, message: string, isLoading = false) => {
  return (
    <div className="message-container">
      <ForgeInlineMessage theme={theme}>
        <div className="message-wrapper">
          {isLoading ? <ForgeCircularProgress /> : null}
          {message}
        </div>
      </ForgeInlineMessage>
    </div>
  );
};

export const PDFPreview: React.FC<PDFPreviewProps> = ({ pdfData, loading, hasTooMayRows }) => {
  if (loading) {
    return renderMessage('info-primary', 'Generating preview.', true);
  }

  if (hasTooMayRows) {
    return renderMessage(
      'danger',
      'PDFs are limited to 5,000 rows. ' +
        'Please add filters to render a more specific table or export data using a different format.'
    );
  }

  if (!pdfData) {
    return renderMessage('danger', 'No preview available');
  }

  return <iframe src={pdfData} width="100%" height="100%" style={{ border: 'none' }} title="PDF Preview" />;
};
